<template>
    <div>
      <div class="bunrui">
          <template class="toplevel" v-for="(item, index) in kaiso1Data" >
            <!--<h3>{{item.Title}}<span>（{{filteredItems(item.Code1,item.Code2)}}件）</span></h3>-->
            
            <h3><a href="javascript:void(0);" @click="click2nd(item)">{{item.Title}}</a><span>（{{filteredItems(item.Code1,item.Code2)}}件）</span></h3>

              <ul>
                <li class="titleSec" v-for="(item2, index2) in kaiso2Data(item)" :key="index2">
                  <!--<a v-bind:href="url(item2.Code1,item2.Code2,item2.Code3)">{{item2.Title}} {{filteredItems2(item2.Code1,item2.Code2,item2.Code3)}}</a>-->
                  <!--<a href="javascript:void(0);" @click="click2nd(item2)">{{item2.Title}}</a>-->

                  <a href="javascript:void(0);" @click="click3nd(item2)">{{item2.Title}}</a>
                  <span>（{{filteredItems2(item2.Code1,item2.Code2,item2.Code3)}}点）</span>
                 <!--<ul  style="margin-left:20px;">-->
                 <ul>
                    <li v-for="(item3, index3) in kaiso3Data(item2)" :key="index3">
                      <!--{{item3.Title}}-->
                      <!--<a href="javascript:void(0);" @click="click3nd(item3)">{{item3.Title}}</a>-->
                      {{item3.Title}}
                    </li>
                  </ul>

                </li>
              </ul>
            </transition>
          </template>
      </div>
    </div>
</template>
<style>
.bunrui a{
    color:#333
}
.titleSec{
    margin-top:20px;
}
.bunrui h3 {
    border-bottom: solid #cfcfcf 1px;
    background-color: #f3f2e7;
    padding: 5px 10px;
}
.bunrui ul{
      list-style: none;
}
</style>
<script>
import axios from 'axios'
export default {
  name: 'Treeside',
  computed: {

    filteredItems () {
       return function(code1,code2){
          var self = this
         return self.$store.getters.kaiso2tbl.filter(function(row, index) {
          if (row.Code1 === code1 && row.Code2 === code2) return true
        }).length

       }
      },
    filteredItems2 () {
       return function(code1,code2,code3){
          var self = this
         return self.$store.getters.kaiso3tbl.filter(function(row, index) {
          if (row.Code1 === code1 && row.Code2 === code2 && row.Code3 === code3) return true
        }).length

       }
      },    

    
    url(){
      return function(code1,code2,code3)
      {
        return `/database/${code1}/${code2}`
      }
    },

    url2(){
      return function(code1,code2,code3)
      {
        return `/database/${code1}/${code2}/${code3}`
      }
    },

    kaiso1Data() {
      return this.$store.getters.kaiso1tbl
    },
    kaiso2Data() {
      return function(item) {
        var self = this
        return self.$store.getters.kaiso2tbl.filter(function(row, index) {
          if (row.Code1 === this.Code1 && row.Code2 === this.Code2) return true
        }, item)
      }
    },
    kaiso3Data() {
      return function(item) {
        var self = this
        return self.$store.getters.kaiso3tbl.filter(function(row, index) {
          if (
            row.Code1 === this.Code1 &&
            row.Code2 === this.Code2 &&
            row.Code3 === this.Code3
          )
            return true
        }, item)
      }
    },
  },
  created: function() {
    var self = this
    self.init()
  },
  data() {
    return {}
  },
  methods: {
    init() {
      this.getAllKaisoData(function(res) {})
    },
    click2nd(item){
       this.$router.push(`/database/${item.Code1}/${item.Code2}`)
    },
    click3nd(item){
       this.$router.push(`/database/${item.Code1}/${item.Code2}/${item.Code3}`)
    }
  }
}
</script>
